import { Directive, Input } from '@angular/core';

import type { TemplateTypeToken } from './typed-template.types';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngTemplateOutletContext]',
})
export class TypedTemplateOutletDirective<TemplateContext> {
  @Input()
  typedTemplate: TemplateTypeToken<TemplateContext>;

  @Input()
  ngTemplateOutletContext: TemplateContext;

  static ngTemplateGuard_ngTemplateOutletContext?<TemplateContext>(
    _dir: TypedTemplateOutletDirective<TemplateContext>,
    _ctx: unknown,
  ): _ctx is TemplateContext {
    return true;
  }
}
